module.exports = __webpack_public_path__ + "img/gs-shape.3a1b2883.png";